import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=6cd45473&scoped=true"
import script from "./confirmation.vue?vue&type=script&lang=js"
export * from "./confirmation.vue?vue&type=script&lang=js"
import style0 from "./confirmation.vue?vue&type=style&index=0&id=6cd45473&prod&lang=scss&scoped=true"
import style1 from "./confirmation.vue?vue&type=style&index=1&id=6cd45473&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd45473",
  null
  
)

export default component.exports